import styles from './Stream.module.scss'
import React, { useEffect, useState } from 'react'
import Header from '../../components/Header/Header'
import ScrollToTop from '../../components/Hooks/ScrollToTop'
import StoryWrapper from '../Stories2/StoryWrapper'
import { useNavigate } from 'react-router-dom'
import { FaAngleLeft } from "react-icons/fa6";
import LiveIndex from '../Live2/LiveIndex'
import GoLive from '../Live2/GoLive'
import LiveAgain from '../Live2/LiveAgain'
import LiveShow from '../Live2/LiveShow'

function Stream() {
    const navigate = useNavigate()

    const [isMobile, setIsMobile] = useState(window.innerWidth < 800);

    const [GoLiveShow, setGoLiveShow] = useState(true);
    const [LiveAgainShow, setLiveAgainShow] = useState(false);
    const [LiveShowShow, setLiveShowShow] = useState(false);

    const onClose = () => {
        navigate('/Home')
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="App">
            <div className="MainContainer">
                <ScrollToTop />
                {(!LiveShowShow || !isMobile) && (<Header />)}

                <div className={`${styles.Container} ${styles.Stories}`}>
                    {LiveShowShow || !isMobile && (
                        <div className={styles.BackButton}>
                            <button onClick={() => { navigate('/Home') }}>
                                <FaAngleLeft /> Back
                            </button>
                        </div>
                    )}
                    <>
                        {GoLiveShow && (
                            <GoLive
                                setLivePopup={onClose}
                                setGoLiveShow={setGoLiveShow}
                                setLiveAgainShow={setLiveAgainShow}
                                setLiveShowShow={setLiveShowShow}
                            />
                        )}
                        {LiveAgainShow && (
                            <LiveAgain
                                setLivePopup={onClose}
                                setGoLiveShow={setGoLiveShow}
                                setLiveAgainShow={setLiveAgainShow}
                                setLiveShowShow={setLiveShowShow}
                            />
                        )}
                        {LiveShowShow && (
                            <LiveShow
                                setLivePopup={onClose}
                                setGoLiveShow={setGoLiveShow}
                                setLiveAgainShow={setLiveAgainShow}
                                setLiveShowShow={setLiveShowShow}
                            />
                        )}
                    </>
                </div>
            </div>
        </div>
    )
}

export default Stream


